import React from 'react';
import { useField } from 'formik';

const CarTerminalInput = () => {
    const [carNumberField, carNumberMeta] = useField('carNumber');
    const [terminalField, terminalMeta] = useField('terminal');

    return (
        <tr>
            <th>Auto nr/terminal</th>
            <td>
                <input
                    {...carNumberField}
                    type="text"
                    placeholder="Auto number"
                />
                {carNumberMeta.touched && carNumberMeta.error && (
                    <div>{carNumberMeta.error}</div>
                )}
                <input
                    {...terminalField}
                    type="text"
                    placeholder="Terminal"
                />
                {terminalMeta.touched && terminalMeta.error && (
                    <div>{terminalMeta.error}</div>
                )}
            </td>
        </tr>
    );
};

export default CarTerminalInput;